import config from "../../app.json";
import axios from "axios";

import "./deleteaccount.scss";
import { Context } from "../../Reducers/Store";
import React, { useState, useContext } from "react";
import { Button } from "react-bootstrap";
import FieldText from "../Fields/FieldText";
import AlertComponent from "../AlertComponent";
import { useNavigate } from "react-router-dom";

function DeleteAccount(props) {
  const [state, dispatch] = useContext(Context);
  const [magicWord, setMagicWord] = useState(null);
  let navigate = useNavigate();

  const handleLogout = () => {
    dispatch({ type: "SET_LOGGED", payload: null });
    dispatch({ type: "SET_HUB", payload: null });
    return navigate(`/`, { replace: false });
  };

  const handleSubmit = () => {
    AlertComponent(
      "Delete Account",
      "Do you confirm account deletion?",
      {
        icon: `question`,
        showCancelButton: true,
      },
      () => {
        axios
          .delete(config.API_HM + "/profile")
          .then((res) => {
            AlertComponent("Success", "The account has been successfully deleted");
            handleLogout();
          })
          .catch(function (error) {
            return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
          });
      },
      false,
      "Yes"
    );
  };

  return (
    <div className="delete-account-tab">
      <h2>We're sorry to see you go</h2>
      <p>
        Warning: Deleting your account will permanently remove all of your data and cannot be undone. This includes your profile, chats, comments, and any other information
        associated with your account. Are you sure you want to proceed with deleting your account?
      </p>
      <small className="dark">To delete the account, please type: DELETE in the box below</small>
      <div></div>
      <div className="deleteaccount-section">
        <FieldText
          type="text"
          onChange={(x) => setMagicWord(x.target.value)}
          label="Type DELETE to confirm"
          placeholder=""
          value={magicWord}
          required={true}
          inputClassName={`deleteaccount-input-option`}
        />
      </div>
      <div className="deleteaccount-section">
        <Button className="big-delete-btn" onClick={handleSubmit} disabled={!magicWord || magicWord !== `DELETE`}>
          Delete Account
        </Button>
      </div>
    </div>
  );
}

export default DeleteAccount;
